import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { SpecificSearchToneAPI } from '../api/search/specificsearchtone/specificsearchtoneapi';
import { SpecificSearchToneRequest } from '../api/search/specificsearchtone/specificsearchtonerequest';
import { SpecificSearchToneResponse } from '../api/search/specificsearchtone/specificsearchtoneresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { SpecificSearchToneAPIProcessorImpl } from '../processor/specificsearchtoneapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class SpecificSearchToneProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(SpecificSearchToneProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getSpecificSearchTone():APIProcessor<SpecificSearchToneRequest, SpecificSearchToneResponse>
    {
        this.logger.log("getSpecificSearchTone() invoked");
        return new SpecificSearchToneAPIProcessorImpl(this.getContext(), new SpecificSearchToneAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/specificsearchtoneprocessorfactory.tsx